import React from 'react';
import classes from './PaginationWrapper.module.css';
import { isTruthy } from '../../../Helpers';
const PaginationWrapper = ({ children, limit, totalCount }) => {

  
  return (
    <div className={[classes.wrapper, 'flex_grid_justify-content-between'].join(' ')}>
      <p>{`Showing ${isTruthy(limit)} items out of ${isTruthy(totalCount)} results found`}</p>
      {children}
    </div>
  );
};

export default PaginationWrapper;
